import React, { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";

const JoinUser = () => {
  const [donors, setDonors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDonation, setSelectedDonation] = useState({});
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [role, setRole] = useState(null);
  const [notFoundMessage, setNotFoundMessage] = useState("");
  const [shouldFetch, setShouldFetch] = useState(false);
  const axiosAPI = useAxios();

  const [filters, setFilters] = useState({
    level: "",
    search: "",
  });

  // Handler to update filters
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleResetFilters = () => {
    setFilters({
      level: "",
      search: "",
    });
    setPage(1);
    setShouldFetch(true);
  };

  const handleSearchClick = () => {
    setPage(1); // Reset page
    fetchDonors(filters, 1); // API call manually
  };

  const handlePageClick = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setPage(pageNum);
    }
  };

  const buildQuery = (filterObj, currentPage) => {
    const params = new URLSearchParams();
    // console.log("Params", params);

    Object.entries(filterObj).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    params.append("page", currentPage);
    return params.toString();
  };
  const fetchDonors = async (customFilters = filters, customPage = page) => {
    setLoading(true);
    setNotFoundMessage(""); // reset error

    try {
      const queryString = buildQuery(customFilters, customPage);
      const response = await axiosAPI.get(
        `/api/joined-donors/get-joined-donors?${queryString}`
      );

      // console.log("Data", response.data);

      if (response.data?.donors?.length > 0) {
        setDonors(response.data.donors);
        setTotalPages(response.data.totalPages);
      } else {
        setDonors([]); // clear previous data
        setNotFoundMessage("No data found.");
      }
    } catch (err) {
      console.error("Error fetching donors:", err);

      setDonors([]); // clear previous data

      if (err.response?.status === 404) {
        setNotFoundMessage("No data found.");
      } else {
        setNotFoundMessage("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchDonors();
  // }, []);
  useEffect(() => {
    fetchDonors();
  }, [page]);

  // console.log("Donors:", donors);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center mb-3 gap-2">
          {/* Right side: Buttons container */}
        </div>
        {/* Bootstrap Modal */}
        <div
          className="modal fade"
          id="donationModal"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Join Donors Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  // onClick={closeModal}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                {/* Left side */}
                <h4 className="card-title mb-0">
                  Joined Donors Details ({donors.length})
                </h4>

                {/* Right side: Search + Dropdown */}
                {/* <div className="d-flex flex-wrap align-items-center gap-3">
                  <div
                    className="position-relative"
                    style={{
                      flexGrow: 1,
                      minWidth: "280px",
                      marginTop: "20px",
                    }}
                  >
                    <input
                      className="form-control shadow-sm px-3 py-2 border-2 w-100"
                      type="text"
                      placeholder="Enter name, phone number, or email"
                      value={filters.search}
                      aria-label="Search"
                      onChange={(e) =>
                        handleFilterChange("search", e.target.value)
                      }
                      style={{ paddingRight: "110px" }}
                    />
                  </div>

                  <div>
                    <button
                      className="btn btn-primary rounded-pill px-4"
                      onClick={handleSearchClick}
                      style={{
                        marginTop: "20px",
                      }}
                    >
                      Search
                    </button>
                  </div>

                  <div
                    className="d-flex flex-column"
                    style={{
                      marginTop: "20px",
                    }}
                  >
                    <button
                      className="btn btn-icon btn-round btn-dark py-3 px-3  me-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Reset Filters"
                      onClick={handleResetFilters}
                    >
                      <i className="fas fa-sync-alt"></i>
                    </button>
                  </div>
                </div> */}
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Donor Id</th>
                        <th>Phone Number</th>
                        <th>Action</th>
                        {role === "admin" && <th>Action</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : notFoundMessage ? (
                        <tr>
                          <td colSpan="6" className="text-center text-danger">
                            {notFoundMessage}
                          </td>
                        </tr>
                      ) : donors.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : (
                        donors.map((donor) => {
                          return (
                            <tr key={donor.id}>
                              <td>{donor.full_name || "No name assigned"}</td>
                              <td>{donor.donor_id}</td>
                              <td>{donor.phone_number || "null"}</td>
                              <td>
                                {/* <button
                              className="btn btn-dark btn-round btn-icon btn-sm me-2"
                              onClick={() => openReceiptModal(donor.id)}
                            >
                              <i className="fas fa-download"></i>
                            </button> */}

                                <button
                                  className="btn btn-dark btn-round btn-icon btn-sm me-2"
                                  // onClick={() => openUserDetailsModal(donor.id)}
                                >
                                  <i className="fas fa-eye"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <nav aria-label="Page navigation">
              <ul className="pagination flex justify-content-end">
                {/* First Page */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(1)}
                  >
                    First
                  </button>
                </li>

                {/* Previous */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(page - 1)}
                  >
                    Previous
                  </button>
                </li>

                {/* Page Number Buttons in chunks */}
                {(() => {
                  const pageNumbers = [];
                  const maxPagesToShow = 5;
                  const startPage =
                    Math.floor((page - 1) / maxPagesToShow) * maxPagesToShow +
                    1;
                  const endPage = Math.min(
                    startPage + maxPagesToShow - 1,
                    totalPages
                  );

                  for (let i = startPage; i <= endPage; i++) {
                    pageNumbers.push(
                      <li
                        key={i}
                        className={`page-item ${page === i ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageClick(i)}
                        >
                          {i}
                        </button>
                      </li>
                    );
                  }
                  return pageNumbers;
                })()}

                {/* Next */}
                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(page + 1)}
                  >
                    Next
                  </button>
                </li>

                {/* Last Page */}
                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(totalPages)}
                  >
                    Last
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinUser;
